// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_2d_GJ","outer":"w7_8R","heading":"M-B5a","description":"_1TG5n","buttonWrapper":"PgeGh"};